import { createContext, useEffect, useState } from "react";
import * as React from "react";
import { useLocation, useParams } from "react-router-dom";

export const SaveInspectionContext = createContext({
  saveInspectionHandler: null,
  setSaveInspectionHandler: null
});
const SaveInspectionContextContainer = ({ children }) => {
  const [saveInspectionHandler, setSaveInspectionHandler] = useState(null);

  return <SaveInspectionContext.Provider
    value={{ saveInspectionHandler, setSaveInspectionHandler }}>{children}
  </SaveInspectionContext.Provider>;
};
export default SaveInspectionContextContainer;